import React, { useState } from 'react';
import Logo from 'assets/icons/logo.svg';
import './UpdateMobileApp.scss';

const appStore = '/images/apple-app-store.svg';

const UpdateMobileApp = () => {
  const [copied, setCopied] = useState(false);
  const downloadLink = 'https://play.google.com/store/apps/details?id=dk.poulschmith.absystem';

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(downloadLink);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Clipboard copy failed', err);
    }
  };

  return (
    <div className="update-mobile-app">
      {/* Logo */}
      <div className="logo-wrapper">
        <Logo width="100%" height="auto" />
      </div>

      {/* Title */}
      <h1 className="title">AB18-GUIDEN</h1>

      <hr className="divider" />

      {/* Intro Text */}
      <p className="description">
        Vi har lanceret en ny version af appen.
        <br />
        <strong>Vælg den mulighed, der passer til din enhed:</strong>
      </p>

      {/* Platform sections */}
      <div className="platforms">
        {/* iPhone */}
        <div className="platform-card">
          <h3 className="platform-title">iPhone</h3>
          <p className="platform-desc">
            Tryk på App Store-ikonet for at hente den nye version.
          </p>
          <a
            href="https://itunes.apple.com/us/app/ab18-guiden/id1452199697?mt=8"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={appStore}
              alt="Hent i Apple App Store"
              className="store-img"
            />
          </a>
        </div>

        {/* Android */}
        <div className="platform-card">
          <h3 className="platform-title">Android</h3>
          <p className="platform-desc">
            Kopiér linket nedenfor og indsæt det i din browser for at downloade
            appen.
          </p>

          <div className="copy-box">
            <input
              type="text"
              readOnly
              value={downloadLink}
              className="copy-input"
              onClick={(e) => e.target.select()}
            />
          </div>
          <button type="button" className="copy-btn" onClick={handleCopy}>
            {copied ? 'Kopieret!' : 'Kopiér link'}
          </button>
        </div>
      </div>

      <p className="note">
        Denne version understøttes ikke længere. Opdater venligst appen for at
        fortsætte med at bruge AB18-guiden.
      </p>
    </div>
  );
};

export default UpdateMobileApp;
